const mediaSizeCache = new Map();
const mediaSizeTasks = new Map();

function getMediaCacheKey(item) {
    if (!item) {
        return "";
    }
    if (item.kind === "video") {
        return item.videoUrl || item.coverUrl || "";
    }
    return item.originUrl || item.thumbUrl || item.videoUrl || item.coverUrl || "";
}

function setCachedMediaSize(item, size) {
    const key = getMediaCacheKey(item);
    if (!key || !size || !size.width || !size.height) {
        return;
    }
    mediaSizeCache.set(key, {
        width: Number(size.width),
        height: Number(size.height)
    });
}

function getEmbeddedMediaSize(item) {
    if (!item) {
        return null;
    }
    const width = Number(item.width);
    const height = Number(item.height);
    if (!width || !height) {
        return null;
    }
    return { width, height };
}

function getCachedMediaSize(item) {
    const embedded = getEmbeddedMediaSize(item);
    if (embedded) {
        setCachedMediaSize(item, embedded);
        return embedded;
    }
    const key = getMediaCacheKey(item);
    return key ? mediaSizeCache.get(key) : null;
}

function loadImageSize(item) {
    return new Promise((resolve, reject) => {
        const image = new Image();
        image.onload = () => resolve({
            width: image.naturalWidth || image.width,
            height: image.naturalHeight || image.height
        });
        image.onerror = reject;
        image.src = item.originUrl || item.thumbUrl;
    });
}

function loadVideoSize(item) {
    return new Promise((resolve, reject) => {
        const video = document.createElement("video");
        video.preload = "metadata";
        video.muted = true;
        video.onloadedmetadata = () => {
            resolve({
                width: video.videoWidth,
                height: video.videoHeight
            });
        };
        video.onerror = reject;
        video.src = item.videoUrl;
    });
}

function ensureMediaSize(item) {
    const cached = getCachedMediaSize(item);
    if (cached) {
        return Promise.resolve(cached);
    }
    const key = getMediaCacheKey(item);
    if (!key) {
        return Promise.reject(new Error("empty media key"));
    }
    if (mediaSizeTasks.has(key)) {
        return mediaSizeTasks.get(key);
    }
    const loader = item.kind === "video" ? loadVideoSize(item) : loadImageSize(item);
    const task = loader.then((size) => {
        setCachedMediaSize(item, size);
        return size;
    }).finally(() => {
        mediaSizeTasks.delete(key);
    });
    mediaSizeTasks.set(key, task);
    return task;
}

function ensureMediaSizes(items = []) {
    return Promise.allSettled(items.map((item) => ensureMediaSize(item)));
}

export {
    getMediaCacheKey,
    getEmbeddedMediaSize,
    getCachedMediaSize,
    setCachedMediaSize,
    ensureMediaSize,
    ensureMediaSizes
};
